import I18n from 'i18n-js';
import React, { useState } from 'react';

import { RCText, RCModal, RCButtonSpan } from '@reverbdotcom/cadence/components';
import { FormCards } from '@reverbdotcom/commons/src/components/FormCards';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import VideoEmbed from '@reverbdotcom/commons/src/components/video_embed';
import { PlayIcon } from '@reverbdotcom/cadence/icons/react';
import videoPreviewImg from '../../../../../../images/reverb-guitar-shipping-thumbnail.png';
import URLHelpers from '../../../../shared/url_helpers';

const GUITAR_SHIPPING_TIPS_VIDEO_SLUG = '9uvYDulN_7k';

export default function GuitarPackagingTipsCallout() {
  const [modalOpen, setModalOpen] = useState(false);
  function handleKeyUp(event) {
    if (event.key === 'Enter') {
      setModalOpen(!modalOpen);
    }
  }

  return (
    <FormCards.Card>
      <FormCards.FormSection>
        <div className="guitar-packaging-tips-callout">
          <div className="guitar-packaging-tips-section">
            <RCText.Title size="500">
              {I18n.t('discovery.sellForm.shippingSection.guitarPackagingTip.title')}
            </RCText.Title>
            <div>
              <RCText.Utility size="400">
                {I18n.t('discovery.sellForm.shippingSection.guitarPackagingTip.body')}
                <CoreLink
                  className="button-as-link text-utility-350 fg-color-text-secondary td-underline"
                  to={URLHelpers.guitarShippingGuidePath}
                  target="_blank"
                >
                  {I18n.t('discovery.sellForm.shippingSection.guitarPackagingTip.needMoreHelp')}
                </CoreLink>
              </RCText.Utility>
            </div>
          </div>
          <div className="d-flex mobile-width-40">
            <button
              onClick={() => { setModalOpen(!modalOpen); }}
              onKeyUp={handleKeyUp}
              type="button"
              className="d-block button-as-link"
            >
              <div className="guitar-packaging-tips-image">
                <img
                  alt={I18n.t('discovery.sellForm.shippingSection.guitarPackagingTip.videoAltText')}
                  src={videoPreviewImg}
                  className="d-block width-100"
                />
                <RCButtonSpan
                  variant="loud"
                  size="medium"
                  iconOnly={<PlayIcon weight="fill" />}
                  iconLabel={I18n.t('discovery.sellForm.shippingSection.guitarPackagingTip.playVideo')}
                  hideTooltip
                />
              </div>
            </button>
          </div>
        </div>
        <RCModal
          isOpen={modalOpen}
          onOpenChange={(state) => {
            if (state === false) setModalOpen(false);
          }}
          title={{ 'aria-labelledby': 'sell-form-shipping-guitar-video' }}
        >
          <VideoEmbed slug={GUITAR_SHIPPING_TIPS_VIDEO_SLUG} />
        </RCModal>
      </FormCards.FormSection>
    </FormCards.Card>
  );
}
